import requester from '@/utils/request'
export const subscribeService: any = {
  // 订阅者查看订阅列表
  subscribeTierList: (data: any) => requester.post('/subscribe-to-creator/tier/list', data),
  // 订阅者列表
  fetchSubscriberList: (data: any) => requester.post('subscribe-to-creator/subscriber/list', data),
  // 订阅-使用stripe
  subscribeStripe: (data: any) => requester.post('/subscribe-to-creator/subscribe/stripe', data),
  // 订阅者查看订阅列表
  subscribeList: (data: any) => requester.post('/subscribe-to-creator/subscribe/list', data),
  // 取消订阅
  subscribeCancel: (data: any) => requester.post('/subscribe-to-creator/subscribe/cancel', data),
  // 查看在指定创作者下订阅中的tier
  subscribeTier: (data: any) =>
    requester.post('/subscribe-to-creator/subscribe/subscribing-tier', data),
  // 列表数量统计
  subscribeCount: (data: any) => requester.post('/subscribe-to-creator/subscribe/count', data),
  // 查询订阅gas fee
  gasEstimate: (data: any) => requester.post('/subscribe-to-creator/subscribe/gasEstimate', data),
  // 新增订阅优惠
  subscribePromotionAdd: (data: any) => requester.post('/subscribe/promotion/add', data),
  // 根据tierId查询关联的promotion
  subscribePromotionListByTier: (tierId: string) =>
    requester.post('/subscribe/promotion/list/by-tier', { tierId }),
  // 停止订阅优惠
  subscribePromotionStop: (id: string) => requester.post('/subscribe/promotion/stop', { id }),
  // 创作者订阅tier详情
  getSubscriptionTier: (data: any) => requester.post('/subscribe-to-creator/tier/detail', data),
  // 购买前 前置检查 免费订阅
  checkFreeSubscribe: (data: any) =>
    requester.post('/subscribe-to-creator/tier/get-available-promotion', data),
  // 查询订阅通知列表
  checkHomeSubscribe: (data: any) =>
    requester.post('/subscribe-to-creator/notification/find-list', data),
  // 忽略首页通知
  handleHomeSubscribe: (id: number | string) =>
    requester.post('/subscribe-to-creator/notification/dismiss?id=' + id, {}),
  // 新建 saveSubscriptionBundles
  addSubscriptionBundles: (data: any) => requester.post('/subscription-bundle/v1/add', data),
  // 编辑 editSubscriptionBundles
  editSubscriptionBundles: (data: any) => requester.post('/subscription-bundle/v1/update', data),
  // 查询 getSubscriptionBundles
  getSubscriptionBundles: (data: any) => requester.post('/subscription-bundle/v1/query', data),
  // 删除 deleteSubscriptionBundles
  deleteSubscriptionBundles: (data: any) => requester.post('/subscription-bundle/v1/del', data),
  // 订阅者查看自己所有的订阅包列表
  getSubscriptionBundlesUser: (data: any) =>
    requester.post('/subscription-bundle-user/v1/subscribing/list', data),
  // 手动取消订阅订阅包
  cancelSubscribeBundle: (data: any) => requester.post('/subscription-bundle-user/v1/cancel', data),
  // 订阅者查看自己所有的订阅包列表
  getSubscriptionBundlesList: (data: any) =>
    requester.post('/subscription-bundle-user/v1/subscribing/list', data),
  // 订阅者统计
  getSubscriberStatistic: (data: any) =>
    requester.post('/subscribe-to-creator/subscriber/statistic', data),
}
